import { useEffect, useRef } from 'react';
import { shortId } from './format';

// The gallery's index: the same contact-sheet strip the generator uses for zoom
// history, so the two views share one vocabulary for "the set of images in play"
// (and, deliberately, the same CSS). Here it indexes saved specimens instead of
// this session's zooms.
//
// A frame with no thumbnail yet is a slot, not a gap — the strip's length is
// correct from the first paint and nothing reflows as images arrive.
const GalleryStrip = ({ entries, thumbs, activeId, onSelect }) => {

    const activeRef = useRef(null);

    // Keep the current specimen visible when navigating by keyboard or swipe;
    // without this the strip silently falls out of sync past the tenth entry.
    useEffect(() => {
        const node = activeRef.current;
        if (node && typeof node.scrollIntoView === 'function') {
            node.scrollIntoView({ block: 'nearest', inline: 'center' });
        }
    }, [activeId]);

    return (
        <div id="filmstrip">
            <div className="filmstrip-inner">
                {entries.map((entry, i) => {
                    const isActive = entry.id === activeId;
                    return (
                        <button
                            type="button"
                            key={entry.id}
                            ref={isActive ? activeRef : null}
                            className={`thumb${isActive ? ' active' : ''}`}
                            aria-current={isActive ? 'true' : undefined}
                            onClick={() => onSelect(i)}
                            title={`Specimen ${shortId(entry.id)}`}
                        >
                            <span className="thumb-index">{i + 1}</span>
                            {thumbs[entry.id]
                                ? <img src={thumbs[entry.id]} alt={`Specimen ${shortId(entry.id)}`} />
                                : <span className="thumb-pending" aria-hidden="true" />}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default GalleryStrip;
